import {useState} from 'react'
import {Box, Flex, Image, Text, useToast} from '@chakra-ui/react'
import Logo from '@assets/svgs/logo.svg'
import {CommonColors} from '@utils/CommonStyles'
import {useNavigate} from 'react-router-dom'
import {AUTH_ACTION, PATH, STATUS_CODE} from '@utils/Const'
import {Button, Form, Input} from 'antd'
import VerifyPassword from './VerifyPassword'
import appRequest from '@apis/app'
import Otp from './Otp'
import Loading from '@components/Loading'

const ForgetPassword = () => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const [isTypePhone, setIsTypePhone] = useState(true)
  const [isVerifyPassword, setIsVerifyPassword] = useState(false)
  const [user, setUser] = useState(null)
  const toast = useToast()

  const handleGoHome = () => {
    navigate(PATH.HOME)
  }

  const onFinish = async (values: any) => {
    setIsLoading(true)
    const data = await appRequest.verifyPhone({
      phone: values?.phone,
      action: AUTH_ACTION.FORGET_PASSWORD,
    })
    if (data?.data?.status === STATUS_CODE.SUCCESS) {
      setUser({...values})
      setIsTypePhone(false)
    } else {
      toast({
        title: data.response?.data?.message || 'Đã có lỗi xảy ra',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
    setIsLoading(false)
  }

  return (
    <Flex sx={styles.container}>
      {isLoading && <Loading />}
      <Image
        w={{base: '300px', md: '400px'}}
        cursor={'pointer'}
        onClick={handleGoHome}
        src={Logo}
        sx={styles.logo}
      />
      {isTypePhone ? (
        <>
          {isVerifyPassword ? (
            <VerifyPassword
              user={user}
              setIsTypePhone={setIsTypePhone}
              setIsVerifyPassword={setIsVerifyPassword}
              setIsLoading={setIsLoading}
            />
          ) : (
            <Box sx={styles.form} w={{base: '100%', md: '480px'}} mx={'16px'}>
              <Flex flexDirection={'column'}>
                <Text sx={styles.title}>Lấy lại mật khẩu</Text>
                <Form
                  name="basic"
                  layout={'vertical'}
                  autoComplete="off"
                  onFinish={onFinish}>
                  <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    rules={[
                      {required: true, message: 'Số điện thoại không hợp lệ'},
                      {min: 10, max: 12, message: 'Số điện thoại không hợp lệ'},
                      {
                        pattern: /^[0-9]+$/,
                        message: 'Số điện thoại không hợp lệ',
                      },
                    ]}
                    validateTrigger="onChange"
                    validateFirst>
                    <Input />
                  </Form.Item>
                  <Form.Item style={{marginTop: '30px'}}>
                    <Button
                      htmlType="submit"
                      type="primary"
                      style={styles.button}>
                      Tiếp tục
                    </Button>
                  </Form.Item>
                </Form>
              </Flex>
            </Box>
          )}
        </>
      ) : (
        <Otp
          user={user}
          setUser={setUser}
          setIsVerifyPassword={setIsVerifyPassword}
          setIsTypePhone={setIsTypePhone}
          setIsLoading={setIsLoading}
          handleBack={() => {
            setIsTypePhone(true)
          }}
        />
      )}
    </Flex>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  form: {
    flexDirection: 'column',
    backgroundColor: CommonColors.white,
    padding: 8,
    alignItems: 'center',
    borderRadius: '24px',
    justifyContent: 'center',
  },
  button: {
    width: '100%',
    borderRadius: '12px',
    backgroundColor: CommonColors.blue2,
    height: '46px',
  },
  textRegister: {
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    textAlign: 'center',
  },
  logo: {
    marginBottom: '48px',
  },
}

export default ForgetPassword
